module.exports = __webpack_public_path__ + "imgesssyaa/svg/File-Plus.74fcb28a.svg";